// AdminHome.jsx - Updated with useNavigate

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, BarChart3, Users, Settings } from "lucide-react";

function AdminHome() {
  const navigate = useNavigate();

  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50">
      {/* Main Dashboard View */}
      <div className="max-w-6xl mx-auto px-4 py-8 md:py-12">
        <div className="mb-8 md:mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <h1
              className="text-3xl sm:text-4xl md:text-5xl font-bold bg-gradient-to-r from-purple-600 via-pink-500 to-blue-500 bg-clip-text text-transparent"
              style={{ fontFamily: "Bambino", lineHeight: "1.2" }}
            >
              Admin Dashboard
            </h1>
            <BarChart3 className="w-8 h-8 md:w-12 md:h-12 text-purple-500" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {/* Report Settings Card */}
          <button
            onClick={() => navigate("/admin/reports")}
            className="group bg-white/70 backdrop-blur-md rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 border-2 border-purple-100 hover:border-purple-400"
          >
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="w-16 h-16 md:w-24 md:h-24 bg-gradient-to-br from-purple-100 to-pink-100 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                <BarChart3 className="w-8 h-8 md:w-12 md:h-12 text-purple-600" />
              </div>
              <h2
                className="text-lg md:text-2xl font-bold text-gray-800"
                style={{ fontFamily: "Bambino" }}
              >
                Report Settings
              </h2>
              <p
                className="text-gray-600 text-xs md:text-sm"
                style={{ fontFamily: "Bambino" }}
              >
                View daily, weekly, and monthly sales reports
              </p>
            </div>
          </button>

          {/* Driver Settings Card */}
          <button
            onClick={() => navigate("/admin/drivers")}
            className="group bg-white/70 backdrop-blur-md rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 border-2 border-blue-100 hover:border-blue-400"
          >
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="w-16 h-16 md:w-24 md:h-24 bg-gradient-to-br from-blue-100 to-cyan-100 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                <Users className="w-8 h-8 md:w-12 md:h-12 text-blue-600" />
              </div>
              <h2
                className="text-lg md:text-2xl font-bold text-gray-800"
                style={{ fontFamily: "Bambino" }}
              >
                Driver Settings
              </h2>
              <p
                className="text-gray-600 text-xs md:text-sm"
                style={{ fontFamily: "Bambino" }}
              >
                Manage drivers and view delivery portal
              </p>
            </div>
          </button>

          {/* Website Settings Card */}
          <button
            onClick={() => navigate("/admin/website")}
            className="group bg-white/70 backdrop-blur-md rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-105 border-2 border-green-100 hover:border-green-400"
          >
            <div className="flex flex-col items-center text-center space-y-4">
              <div className="w-16 h-16 md:w-24 md:h-24 bg-gradient-to-br from-green-100 to-emerald-100 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                <Settings className="w-8 h-8 md:w-12 md:h-12 text-green-600" />
              </div>
              <h2
                className="text-lg md:text-2xl font-bold text-gray-800"
                style={{ fontFamily: "Bambino" }}
              >
                Website Settings
              </h2>
              <p
                className="text-gray-600 text-xs md:text-sm"
                style={{ fontFamily: "Bambino" }}
              >
                Manage shop hours, offers, and orders
              </p>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdminHome;